import React from "react";
import "./ui.css";

export function CardHeader({ title, actions, children }) {
  return (
    <div className="ui-card-head">
      {title ? <h3 className="ui-card-title">{title}</h3> : children}
      {actions ? <div className="ui-page-header-actions">{actions}</div> : null}
    </div>
  );
}

export function CardFooter({ children }) {
  return <div className="ui-card-footer">{children}</div>;
}

// Base card shell used by every role's dashboards/list pages -- header/
// body/footer slots matching the already-shipped ".tlp-card" look.
export default function Card({ title, actions, footer, flush = false, className = "", children }) {
  return (
    <div className={["ui-card", className].filter(Boolean).join(" ")}>
      {(title || actions) && <CardHeader title={title} actions={actions} />}
      <div className={flush ? "ui-card-body-flush" : "ui-card-body"}>{children}</div>
      {footer && <CardFooter>{footer}</CardFooter>}
    </div>
  );
}
